export default "__VITE_ASSET__SRKmPxBF__"